import { Text } from '~/components/ui/Text';
import { StyledContainer, StyledDate, StyledLetter } from './Category.styled';

const Category = ({ letter, date }: { letter: string; date: string }) => {
	return (
		<StyledContainer>
			<StyledLetter>
				<Text>{letter}</Text>
			</StyledLetter>
			<StyledDate>
				<Text>{date}</Text>
			</StyledDate>
		</StyledContainer>
	);
};

export { Category };
